// @flow

import styled from 'styled-components';
import { MEDIA, COLORS, FONT_WEIGHT, TYPE_SCALE, SPACING, LINE_HEIGHT } from 'clark-styles';

const { GREY_100 } = COLORS;
const { S_05, S_1, S_2 } = SPACING;
const { FW_700 } = FONT_WEIGHT;
const { TS_3 } = TYPE_SCALE;
const { TITLE } = LINE_HEIGHT;

const Headline = styled.h2`
  ${TS_3};
  ${FW_700};
  ${TITLE};
  color: ${GREY_100};
  margin: ${S_2} 0 ${S_05};

  ${MEDIA.small`
    margin: calc(${S_1} + ${S_2}) 0 ${S_05};
  `};
`;

export default Headline;



// WEBPACK FOOTER //
// ./src/containers/sessions/view-form/styles.js